import React, { useState } from "react";
import { X, ZoomIn } from "lucide-react";
import StatusImage1 from "../assets/p1.png";
import StatusImage3 from "../assets/p5.png";
import StatusImage4 from "../assets/p6.png";
import StatusImage5 from "../assets/p7.png";
import StatusImage6 from "../assets/p8.png";
import StatusImage7 from "../assets/p9.png";
import StatusImage8 from "../assets/p10.png";
import StatusImage9 from "../assets/p11.png";
import StatusImage10 from "../assets/p12.png";

const StatusGallery = () => {
  const [selectedImage, setSelectedImage] = useState(null);

  const images = [
    StatusImage1,
    StatusImage3,
    StatusImage4,
    StatusImage5,
    StatusImage6,
    StatusImage7,
    StatusImage8,
    StatusImage9,
    StatusImage10,
  ];

  const openModal = (img, e) => {
    e.stopPropagation();
    setSelectedImage(img);
  };

  const closeModal = (e) => {
    e.stopPropagation();
    setSelectedImage(null);
  };

  return (
    <>
      <div className="mt-6 md:mt-8 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
        {images.map((img, index) => (
          <div key={index} className="relative group">
            {/* Image Container */}
            <div className="w-full h-64 rounded-lg shadow-lg overflow-hidden ">
              <img
                src={img}
                alt={`Status ${index + 1}`}
                className="w-full h-full object-cover"
              />
              {/* Hover Overlay with Search Icon */}
              <div className=" absolute inset-0 bg-black/50 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center">
                <button
                  className="cursor-pointer"
                  onClick={(e) => openModal(img, e)}
                >
                  <ZoomIn className="text-white w-10 h-10" />
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Fullscreen Modal */}
      {selectedImage && (
        <div
          className="fixed inset-0 bg-black bg-opacity-90 z-50 flex items-center justify-center p-4"
          onClick={closeModal}
        >
          <div
            className="relative w-full max-w-6xl max-h-[90vh]"
            onClick={(e) => e.stopPropagation()}
          >
            {/* Close Button */}
            <button
              className="absolute -top-10 right-0 text-white hover:text-gray-300 transition-colors z-50"
              onClick={closeModal}
            >
              <X className="w-8 h-8" />
            </button>
            {/* Fullscreen Image */}
            <img
              src={selectedImage}
              alt="Fullscreen Preview"
              className="w-full h-full max-h-[90vh] object-contain"
            />
          </div>
        </div>
      )}
    </>
  );
};

export default StatusGallery;
